import { render, staticRenderFns } from "./PageMigration.vue?vue&type=template&id=94bc258c&"
import script from "./PageMigration.vue?vue&type=script&lang=js&"
export * from "./PageMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94bc258c')) {
      api.createRecord('94bc258c', component.options)
    } else {
      api.reload('94bc258c', component.options)
    }
    module.hot.accept("./PageMigration.vue?vue&type=template&id=94bc258c&", function () {
      api.rerender('94bc258c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/PageMigration.vue"
export default component.exports